import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addTransportTrip = (transportTrip) => {
  // primaryTrip = Object.assign({}, primaryTrip)
  const promises = [];
  return http
    .post("/trip/segregation-trip/create", {
      cityId: transportTrip.cityId,
      dumpYardId: transportTrip.dumpYardId,
      segregationId: transportTrip.segregationId,
      driverId: transportTrip.driverId,
      vehicleId: transportTrip.vehicleId,
      tripStatus: transportTrip.tripStatus,
      scheduleTime: transportTrip.scheduleTime,
      userId: transportTrip.userId,
    })
    .then((result) => {
      transportTrip = result.data;
      return result;
    })
    .catch((error) => {
      console.error("Transport trip.inviteUser-error:\n", error);
      throw error;
    });
};

internals.updateTransportTrip = (transportTrip) => {
  // primaryTrip = Object.assign({}, primaryTrip)
  const promises = [];
  return http
    .put("/trip/segregation-trip/update", {
      cityId: transportTrip.cityId,
      dumpYardId: transportTrip.dumpYardId,
      segregationId: transportTrip.segregationId,
      driverId: transportTrip.driverId,
      vehicleId: transportTrip.vehicleId,
      tripStatus: transportTrip.tripStatus,
      scheduleTime: transportTrip.scheduleTime,
      userId: transportTrip.userId,
      _id: transportTrip._id,
    })
    .then((result) => {
      transportTrip = result.data;
      return result;
    })
    .catch((error) => {
      console.error("Transport trip.inviteUser-error:\n", error);
      throw error;
    });
};

internals.vehicleList = (Id) => {
  return http
    .get(`/vehicle/list/number?cityId=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("transPortTripService-error:\n", error);
      throw error;
    });
};

internals.driverList = (Id) => {
  return http
    .get(`/register/driver/list?cityId=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("transPortTripService-error:\n", error);
      throw error;
    });
};

internals.getById = (id) => {
  return http
    .get(`/trip/segregation-trip/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("primaryTripService-error:\n", error);
      throw error;
    });
};

internals.getList = (params) => {
  let parameters = `?page=${params.page}&limit=${params.limit}`;
  if(params.cityIds){
    parameters += `&cityIds=${params.cityIds}`;
  }
  if(params.startLoc){
    parameters += `&startLoc=${params.startLoc}`;
  }
  if(params.endLoc ){
    parameters += `&endLoc =${params.endLoc }`;
  }
  if(params.startDate){
    parameters += `&startDate=${params.startDate}`;
    parameters += `&endDate=${params.endDate}`;
  }
  if(params.sortBy){
    parameters += `&sortBy=${params.sortBy}`;
    parameters += `&sortOrder=${params.sortOrder}`;
  }
  if(params.searchString){
    parameters += `&searchString=${params.searchString}`;
  }
  if(parameters.status){
    parameters += `&status=${params.status}`;
  }
  return http
    .get(`/trip/segregation-trip${parameters}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("primaryTripService-error:\n", error);
      throw error;
    });
};

internals.getListDate = params => {
  return http
    .get(`/trip/segregation-trip?limit=${params.limit}&page=${params.page}&endDate=${params.endDate}&startDate=${params.startDate}`)
    .then(response => {        
      return response
    })
    .catch(error => {
      console.error('primaryTripService-error:\n', error)
      throw error
    })
}
export default internals;



// WEBPACK FOOTER //
// ./src/services/transportPointTrip.service.js